import { takeLatest, put, call, fork } from "redux-saga/effects";
import DBOnBoardingService from "services/db-onboarding-service";
import { DB_ONBOARDING_ACTIONS } from "constants/actions";
import {
    fetchedDBOnBoardingList,
    failedFetchDBOnBoardingList,
} from "actions";
import { message } from "antd";
import { dbOnboardingFailedInvalidateDocument, dbOnboardingInvalidatedDocument } from "../actions/db-onboarding-actions";


function* fetchDBList({ payload }) {
    try {
        const {data, error} = yield call(
            DBOnBoardingService.fetchDBList,
            payload.stage,
            payload.page || 1,
            payload.page_size || 10,
            payload.filters
        )
        if(!error){
            yield put(fetchedDBOnBoardingList(payload.stage, payload.page, payload.page_size, data));
    
        }else{
            yield put(failedFetchDBOnBoardingList(payload.stage, payload.page, payload.page_size, error));
        }
    } catch (error) {
        yield put(failedFetchDBOnBoardingList(payload.stage, payload.page, payload.page_size, error));
    }
}

function* dbOnboardingInvalidateDocumentHandler({ payload: { company_id, file } }) {
    try {
        message.loading("Invalidating Document", 2);
        let payload  = {
            file_name: file.file_name,
            id: file.id,
            document: file.document? file.document.id :null,
            document_status: file.document_status,
            is_active: file.is_active,
            remarks: file.remarks,
            parse_data: file.parse_data,
            request_remarks: file.request_remarks
        }

        const { error } = yield call(
            DBOnBoardingService.validateDocumentDB,
            company_id,
            file.id,
            payload
        );

        if (!error) {
            yield put(dbOnboardingInvalidatedDocument(company_id, file));
            message.info("Invalidated Document", 2);
            return;
        }
        message.info("Failed Invalidate Document", 2);
        yield put(dbOnboardingFailedInvalidateDocument(company_id,  file));
    } catch (error) {

        message.info("Failed Invalidate Document", 2);
        yield dbOnboardingFailedInvalidateDocument(company_id, file, error);
    }
}


export default fork(function*() {
    yield takeLatest(DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_LIST, fetchDBList);
    yield takeLatest(DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT , dbOnboardingInvalidateDocumentHandler)
});